import { useState } from 'react';
import { Modal } from 'antd';
import { CloseXIcon } from 'icons';
import Image from 'next/image';

import { useAppDispatch, useAppSelector } from 'store';

import { closeAuthModal, Login, setStep } from 'modules/auth';

import RegisterStep from './register';

export interface IProfile {
  full_name: string;
  last_name: string;
  role?: string;
  birthday: string;
  gender: string;
  region_id: string;
}

export interface IUserData {
  phone: string;
  code: string;
  profile: IProfile;
}

const defaultProfile: IProfile = {
  full_name: '',
  last_name: '',
  role: '',
  birthday: '',
  gender: '',
  region_id: ''
};

export function AuthModal() {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(state => state.authModal.isOpen);
  const step = useAppSelector(state => state.authModal.step);
  const isRequired = useAppSelector(state => state.authModal.isRequired);
  const [data, setData] = useState<IUserData>({
    phone: '',
    code: '',
    profile: defaultProfile
  });

  const steps = [
    <Login setRegisterStep={() => dispatch(setStep(2))} key="login" />,
    <RegisterStep data={data} setData={setData} key="register" />
  ];

  const onAfterClose = () => {
    dispatch(setStep(1));
  };

  return (
    <Modal
      open={isOpen}
      footer={null}
      zIndex={99999}
      onCancel={() => dispatch(closeAuthModal())}
      width="clamp(525px, 80vw, 1042px)"
      centered
      maskClosable={!isRequired}
      keyboard={!isRequired}
      closable={!isRequired}
      afterClose={onAfterClose}
      closeIcon={
        step === 4 ? null : (
          <div className="flex items-center justify-center p-1 md:p-2">
            <CloseXIcon color="#000" />
          </div>
        )
      }
      styles={{
        content: { padding: '0', borderRadius: '16px' }
      }}
    >
      <div className="flex flex-col items-center p-3 md:flex-row">
        {step !== 4 && (
          <div className="min-h-144 rounded-14 relative hidden w-1/2 items-center justify-center bg-gray-100 md:flex">
            <div className="lg:w-115 lg:h-126 w-90 h-101 absolute bottom-0">
              <Image src="/images/auth.webp" alt="Users" fill title="Ro'yxatdan o'tish modal rasmi" loading="lazy" />
            </div>
          </div>
        )}
        <div className="sm:py-12.5 sm:min-h-144 lg:px-11.5 min-h-80 w-full px-3 py-5 md:w-1/2 md:px-5">
          {steps[step - 1]}
        </div>
      </div>
    </Modal>
  );
}
